module.exports = __webpack_public_path__ + "static/10_work-d54f0ce6c7cbdeb88c7ef9cb216832d8.png";